import React, { useState } from "react";
import Modal from "@/app/core/layouts/main/components/Modal";
import Storage from "@/app/core/util/Storage";
import Field from "../input/Field";
import { FieldTypeObj } from "@/app/core/util/helpers/FieldTypeHelper";
import { OnDataChange } from "@/app/core/util/helpers/FieldHelper";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import { toast } from "react-toastify";
import { Message } from "@/app/core/util/messages/GeralMessages";

export default function EditProfileModal({ show, onHide }) {
    const [data, setData] = useState(Storage.getUserData());

    function handleChange(evt, type) {
        setData(OnDataChange(data, evt, type))
    }

    async function save(){
        await AccountController.Update(data);
        Storage.setUserData(data);
        toast.success(Message.Saved);
        onHide()
    }

    return (
        <Modal
            title="Editar conta"
            show={show}
            size="md"
            onHide={onHide}
            onSubmit={() => save()}>
            <Field
                name="name"
                onChange={(evt) => handleChange(evt)}
                title={"Nome"}
                placeholder={"Nome e sobrenome"}
                value={data && data.name}
                type={FieldTypeObj.Text}
            />
            <Field
                name="email"
                onChange={(evt) => handleChange(evt)}
                placeholder={"usuario@email.com"}
                title={"Email"}
                type={FieldTypeObj.Text}
                value={data && data.email}
            />
            <Field
                name="phone"
                onChange={(evt) =>
                    handleChange({
                        target: {
                            name: evt.target.name,
                            value: evt.target.value.replace(/[^\d]+/g, ""),
                        },
                    })
                }
                title={"Telefone"}
                value={data && data.phone}
                type={FieldTypeObj.Mask}
                mask={"(99) 99999-99999"}
            />
        </Modal>
    )
}